module.exports = __webpack_public_path__ + "img/7_10.abf426a9.png";